import { render, staticRenderFns } from "./DetectNewInvalidDuplicateTags.vue?vue&type=template&id=4fe55a46"
import script from "./DetectNewInvalidDuplicateTags.vue?vue&type=script&lang=js"
export * from "./DetectNewInvalidDuplicateTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports